module.exports = __webpack_public_path__ + "static/media/article.2a68a346.svg";